module.exports = __webpack_public_path__ + "static/media/td_web.6742d6a0.svg";